<template>
	<section>
		<div>
			<!--工具条-->
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
				<el-form :inline="true" :model="filters"  size="mini">
					<el-form-item label="项目名称">
						<el-select v-model="filters.projectId"  @change="getDevices"  filterable>
							<el-option
								v-for="item in projects"
								:label="item.name"
								:value="item.projectId" :key="item.projectId">
							</el-option >
						</el-select>
					</el-form-item>
                    <el-form-item label="点位名称" >
                        <el-select v-model="filters.mn" filterable>
                            <el-option
                                v-for="item in devices"
                                :label="item.name"
                                :value="item.mnCode" :key="item.mnCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备编码"  v-if="type==0">
                        <el-select v-model="filters.mn" filterable>
                            <el-option
                                v-for="item in devices"
                                :label="item.mnCode"
                                :value="item.mnCode" :key="item.mnCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
					<el-form-item label="时间">
						<el-date-picker v-model="filters.time" type="date"  value-format="yyyy-MM-dd"> </el-date-picker>
					</el-form-item>
					
					<el-form-item>
						<my-button  @select-type="clickBtn" QueryButtonShow ExportButtonShow></my-button>
					</el-form-item>
				</el-form>
			</el-col>

			<div id="formDaily"  v-loading="listLoading" style="min-height:500px"  element-loading-text="报表生成中"  element-loading-spinner="el-icon-loading"  element-loading-background="rgba(0, 0, 0, 0.8)">
				<div class="title">
					<span>飞机噪声监测记录表</span>
				</div>
                <el-descriptions class="margin-top" title="" :column="3">
                    <el-descriptions-item label="测点编号">{{obj.no}}</el-descriptions-item>
                    <el-descriptions-item label="测点位置">{{obj.address}}</el-descriptions-item>
                    <el-descriptions-item label="环境背景噪声">{{obj.leqbj}}dB</el-descriptions-item>
                    <el-descriptions-item label="测量日期" >{{obj.date}}</el-descriptions-item>
                    <el-descriptions-item label="监测人">{{obj.people}}</el-descriptions-item>
                    <el-descriptions-item label="测量仪器">{{obj.devicename}}</el-descriptions-item>
                    <el-descriptions-item label="气象条件">气温{{obj.ta}}℃&nbsp;&nbsp;湿度{{obj.ua}}%&nbsp;&nbsp;风向{{obj.wd}}&nbsp;&nbsp;风速{{obj.ws}}m/s</el-descriptions-item>
                </el-descriptions>

                <el-table :data="dataList" border highlight-current-row style="width: 100%;min-height: 400px;" v-loading="listLoading"  size="small"   ref="table">
                    <el-table-column type="index" label="序号"  ></el-table-column>
                    <el-table-column prop="startTime" label="监测时间">
						<template slot-scope="scope">
							<span>{{ scope.row.startTime.split(" ")[0] }}</span>
						</template>
					</el-table-column>
                    <!-- <el-table-column prop="status" label="飞行状态"></el-table-column> -->
                    <el-table-column prop="lmax" label="Lmax(dB)"></el-table-column>
                    <el-table-column prop="td" label="持续时间(s)"></el-table-column>
                    <el-table-column prop="lepn" label="Lepn(dB)"></el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>
                </el-table>
			</div>
		</div>
	</section>
</template>

<script>
	import { getProjects,getDailyMaintRecords,getDevicesByProjectId} from '../../api/api';
	import {formatDateDay} from '../../../static/fun.js';

	import myButton from '../../components/myButton/index.vue'

	export default {
	components: { myButton },
		data() {
			return {
				filters: {
					projectId:"",
                    mn:"",
                    time:''
				},
				listLoading: false,
				dataList:[
					{
						"id": 1,
						"mn": "YS700124010003",
						"startTime": "2024-10-23 08:57:33",
						"endTime": "2024-10-23 08:57:48",
						"lmax": 89.5,
						"lepn": 75.3,
						"td": 15
					},
					{
						"id": 2,
						"mn": "YS700124010003",
						"startTime": "2024-10-23 08:57:58",
						"endTime": "2024-10-23 08:59:52",
						"lmax": 92,
						"lepn": 76.3,
						"td": 114
					},
					{
						"id": 3,
						"mn": "YS700124010003",
						"startTime": "2024-10-23 08:59:58",
						"endTime": "2024-10-23 09:00:28",
						"lmax": 93,
						"lepn": 78.05,
						"td": 20
					},
					{
						"id": 4,
						"mn": "YS700124010003",
						"startTime": "2024-10-23 09:05:18",
						"endTime": "2024-10-23 09:06:26",
						"lmax": 95,
						"lepn": 79.65,
						"td": 68
					},
					{
						"id": 5,
						"mn": "YS700124010003",
						"startTime": "2024-10-23 09:15:18",
						"endTime": "2024-10-23 09:15:43",
						"lmax": 91,
						"lepn": 78.2,
						"td": 25
					},
					{
						"id": 6,
						"mn": "YS700124010003",
						"startTime": "2024-10-23 09:23:33",
						"endTime": "2024-10-23 09:23:49",
						"lmax": 83,
						"lepn": 78.5,
						"td": 16
					},
					{
						"id": 7,
						"mn": "YS700124010003",
						"startTime": "2024-10-23 09:35:39",
						"endTime": "2024-10-23 09:35:51",
						"lmax": 85,
						"lepn": 77.2,
						"td": 12
					},
					{
						"id": 8,
						"mn": "YS700124010003",
						"startTime": "2024-10-23 09:38:40",
						"endTime": "2024-10-23 09:38:48",
						"lmax": 86,
						"lepn": 74,
						"td": 8
					},
					{
						"id": 9,
						"mn": "YS700124010003",
						"startTime": "2024-10-23 09:50:12",
						"endTime": "2024-10-23 09:50:25",
						"lmax": 88,
						"lepn": 78,
						"td": 13
					},
					{
						"id": 10,
						"mn": "YS700124010003",
						"startTime": "2024-10-23 09:55:32",
						"endTime": "2024-10-23 09:55:45",
						"lmax": 99,
						"lepn": 84,
						"td": 13
					},
					{
						"id": 11,
						"mn": "YS700124010003",
						"startTime": "2024-10-23 21:32:14",
						"endTime": "2024-10-23 21:32:18",
						"lmax": 85,
						"lepn": 75,
						"td": 4
					}
                ],
				projects:[],
				formHeight:0,
				date:'',
				errList:[],


                type:sessionStorage.getItem("type"),
                devices:[],


                obj:{
                    no:"001",address:"北门",leqbj:"49",date:"2024年8月9日",people:"测试员",ta:"23",ua:"56",ws:"0",wd:"北风",devicename:"便携噪声"
                }
			}
			
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getDataList();
				}else if(type=="export"){
					this.downFileZip();
				}
			},
		//查询项目信息
        getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
			//获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
					//如果当前已选的设备不属于选中的项目，把设备置空
					var flag=false;
					if(this.filters.deviceId!=""){
						this.devices.forEach(item => {
							if(item.mnCode==this.filters.mn){
								flag=true;
							}
						});		
					}
					if(!flag&&this.devices.length>0){
						this.filters.mn=this.devices[0].mnCode;
					}
					if(this.firstFlag){
						this.firstFlag=false;
						this.getDataList();
					}
				});
            },
			//获取历史数据信息
			getDataList(){
				let para = {
                    projectId: this.filters.projectId,
					time: this.filters.time
				};
				this.listLoading = true;
                getDailyMaintRecords(para).then((res) => { 
					this.listLoading = false;
					if(res.data.result=="true"||res.data.result==true){
						this.dataList = res.data.datas; 
					
					}else{
						this.$message({
							message: "查询失败，请重试",
							type: 'error'
						})
					}
                });
			},  
			downFileZip(){
                require.ensure([], () => {
					let tHeader3=["每日运维记录   日期："+this.date,'','','','','','','','','','','','',''];
                    let tHeader2=['点位名称','采集率（%）','定时远程自检','','','远程维护','','','数据审核','','','','',''];
                    let tHeader1=['','','状态','时间','差值','运行状况','时钟日历','数据传输',
							'噪声事件录音','风速≥5m/s（条数）','降雨量＞0（条数）','小时数据','昼间数据','夜间数据'];

                    let merges = [
						"A1:N1",
                        "A2:A3",
                        "B2:B3",
                        "C2:E2",
                        "F2:H2",
                        "I2:N2"
                    ]; 
                    const { export_json_to_excel_Three } = require('vendor/Export2Excel');
                    const filterVal = ['name', 'dar', 'selfCheckStatus','selfCheckTime','selfCheckDiff','runStatus','timeStatus','dataTrans',
							'recording','ws','rc','hourData','ld','ln' ];  
					
                    var data=[];
                    data.push(this.formatJson(filterVal, this.dataList));

                    var sheetName=[];
                    sheetName.push('Sheet1');

                    export_json_to_excel_Three(tHeader1,tHeader2,tHeader3,data, '每日运维记录-'+this.filters.time,sheetName,merges);

                }) 
			} ,
			formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            }, 
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			},
			setTime(){
				var start = new Date();
				start.setTime(start.setDate(start.getDate()-1));
				this.filters.time= "2024-10-23";
				this.getProjects();
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			
			this.setTime();
		}, 
	}

</script>

<style  scoped>
	@import '../../../static/ywPort.css';
</style>


// WEBPACK FOOTER //
// FlightDayForm.vue?96d45f74